import { Autocomplete } from '@mui/lab'
import { TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { get } from '../helpers/Api'
import config from '../../config.json'
import Link from '../common/util/input/Link'

export const NavigationSearch = () => {
    const [tempSearch, setTempSearch] = useState('')
    const [searchOptions, setSearchOptions] = useState([])
    const [timer, setTimer] = useState(null)

    useEffect(() => {}, [searchOptions])

    const parseQuickSearch = (res) => {
        const newOptions = []
        if (res && !res.error)
            for (const item of res) {
                newOptions.push({
                    label: item['label'],
                    collection: item['collection'],
                    id: item['id'],
                    type: item['type'],
                    image: item['image'],
                    video: item['video'],
                })
            }
        setSearchOptions(newOptions)
    }

    const quickSearch = (e) => {
        const val = e.target.value
        setTempSearch(val)
        if (timer) {
            clearTimeout(timer)
        }
        setTimer(
            setTimeout(() => {
                get('quick-search/' + escape(e.target.value), 'legacy').then(
                    parseQuickSearch,
                )
            }, 200),
        )
    }

    return (
        <div>
            <div className="mx-auto">
                <Autocomplete
                    id="free-solo-2-demo"
                    options={searchOptions}
                    freeSolo
                    disableClearable
                    renderOption={(props, option) => {
                        const { label, collection, id, type, image, video } =
                            option
                        const preview =
                            video || image
                                ? config.ipfspreviewhash
                                      .replace('{collection}', collection)
                                      .replace('{hash}', video ? video : image)
                                      .replace('{size}', '80')
                                : ''

                        return (
                            <Link
                                href={
                                    type === 'collection'
                                        ? `/collection/${collection}`
                                        : type === 'drops'
                                        ? `/drops/${id}`
                                        : `/template/${id}`
                                }
                            >
                                <div className={'flex cursor-pointer'}>
                                    <div className={'my-auto mr-2 h-12'}>
                                        {preview ? <img src={preview} /> : ''}
                                    </div>
                                    <div className={'my-auto'}>
                                        {label} (
                                        {type.charAt(0).toUpperCase() +
                                            type.slice(1)}
                                        )
                                    </div>
                                </div>
                            </Link>
                        )
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            fullWidth
                            value={tempSearch}
                            onChange={quickSearch}
                            size="small"
                            variant="outlined"
                            label={'Search'}
                            inputRef={(input) => {
                                if (input != null) {
                                    input.focus()
                                }
                            }}
                        />
                    )}
                />
            </div>
        </div>
    )
}

export default NavigationSearch
